"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perUnitFormat = exports.isImperial = exports.numberToPercentage = exports.numberToDistance = void 0;
var base_1 = require("./base");
var constants_1 = require("../utils/constants");
/**
 * 数字转度量衡
 * @return {string}
 */
function numberToDistance(number, unit, precision, isHighLight) {
    var numberPattern = (0, base_1.getNumberPattern)();
    var distanceFormat = new base_1.DistanceFormat(number, unit);
    if (distanceFormat.getCurUnit() === constants_1.InitUnitMap.MILE) {
        var ydmiFormat = new base_1.YDMIFormat(number, unit);
        var numberformat_1 = (0, base_1.formatNumber)(ydmiFormat.getNumber(), precision, numberPattern);
        return ydmiFormat.pattern(numberformat_1, isHighLight);
    }
    var numberformat = (0, base_1.formatNumber)(distanceFormat.getNumber(), precision, numberPattern);
    return distanceFormat.pattern(numberformat, isHighLight);
}
exports.numberToDistance = numberToDistance;
/**
 * 数字转度百分比
 * @return {string}
 */
function numberToPercentage(number, isHighLight) {
    var locale = (0, base_1.getBaseInfo)().locale;
    var numFormat = new Intl.NumberFormat(locale, { style: 'decimal' });
    var percentFormat = new Intl.NumberFormat(locale, { style: 'percent' });
    var formattedNumber = numFormat.format(number * 100);
    var formattedPercent = percentFormat.format(number);
    return isHighLight
        ? formattedPercent.replace(formattedNumber, "{".concat(formattedNumber, "}"))
        : formattedPercent;
}
exports.numberToPercentage = numberToPercentage;
/**
 * 是否英制
 * @return {Boolean}
 */
function isImperial(country) {
    return Boolean((0, base_1.isEN)(country));
}
exports.isImperial = isImperial;
/**
 * 每单位距离的格式化
 * @return {Boolean}
 */
function perUnitFormat(string, unit) {
    var pattern = (0, base_1.getDistancePattern)();
    var template = pattern[constants_1.UnitMap[unit]];
    return template.replace('{0}', string);
}
exports.perUnitFormat = perUnitFormat;
